module.exports = __webpack_public_path__ + "杂志.png?011c18178653fd942a700bf2d5261d73";


//////////////////
// WEBPACK FOOTER
// ./src/assets/杂志.png
// module id = 635
// module chunks = 0